<template>
	<div>
		<div class="columns">
			<div class="column is-8">
				<nav class="breadcrumb has-succeeds-separator has-text-weight-bold" aria-label="breadcrumbs">
					<ul>
						<li><a rel="noreferrer" href="#">{{ t('home') }}</a></li>
						<li class="is-active"><a rel="noreferrer" href="#" aria-current="page">{{ t('merchants') }}</a></li>
					</ul>
				</nav>
			</div>
            <div class="column is-2">
                <div class="control is-expanded has-text-left">
                    <div class="custom-vue-select is-fullwidth is-rounded is-primary is-size-6">
                        <multiselect selectLabel="" deselectLabel="" selectedLabel="" v-model="selectedCategory" :options="categories" :placeholder="t('select_category')" label="name" track-by="id"></multiselect>
                        <!--<pre class="language-json"><code>{{ selectedCategory  }}</code></pre>-->
                    </div>
                </div>
            </div>
			<div class="column is-2">
				<div class="control is-expanded has-text-left">
					<div class="custom-vue-select is-fullwidth is-rounded is-primary is-size-6">
						<multiselect selectLabel="" deselectLabel="" selectedLabel="" v-model="selectedCity" :options="cities" :placeholder="t('select_city')" label="name" track-by="id"></multiselect>
						<!--<pre class="language-json"><code>{{ selectedCity  }}</code></pre>-->
					</div>
				</div>
			</div>
		</div>
		<div v-infinite-scroll="loadNextPage" infinite-scroll-disabled="busy" infinite-scroll-distance="6">
			<div class="columns is-multiline is-mobile mt40">
				<div v-for="merchant in merchants" class="column is-2-desktop is-4-tablet is-12-mobile hvr-grow wow zoomIn" data-wow-duration="1s" data-wow-delay=".5s">
					<div class="card has-background-white overflow-hidden">
						<a rel="noreferrer" :href="merchant.route" class="is-block">
							<figure class="image image-cover height-160">
								<lazy-load
								:src="merchant.image"
								:lazy-src="merchant.image ? merchant.image : '/front/img/img.png'"
								:lazy-srcset="merchant.image ? merchant.image : '/front/img/img.png'"
								background-color="transparent"
								:alt="merchant.company_name"
								:lazy-height="200"
								:lazy-width="200"
								/>
							</figure>
						</a>
						<a rel="noreferrer" :href="merchant.route" class="display-table w-100 hvr-shutter-out-vertical height-80 is-block has-background-warning has-text-centered has-text-weight-bold has-text-white p5">
							<span class="display-table-cell vertical-align">
								<span class="is-block height-50 overflow-hidden">
									{{ merchant.company_name }}
								</span>
							</span>
						</a>
					</div>
				</div>
			</div>
			<div class="has-text-centered" v-if="loadMore">
				<a rel="noreferrer" class="button is-primary hvr-shutter-out-vertical hvr-warning is-rounded p25 pr40 pl40" href="#">{{ t('load_more')}}</a>
			</div>
		</div>
	</div>
</template>
<script>
	import axios from 'axios';
	import infiniteScroll from 'vue-infinite-scroll';
	import trans from '../translation/categories.json';
	import Multiselect from 'vue-multiselect'
	import 'vue-multiselect/dist/vue-multiselect.min.css'
	export default {
		name: 'MerchantsPage',
		directives: {
			infiniteScroll
		},
		components:{
			Multiselect
		},
		props: {
			data: {
				type: Array,
				default: () => []
			},
			url: String,
			sitelocale:{
				type:String,
				required: true
			},
			cities:{
				type: Array,
				default: () => []
			},
			categories:{
				type: Array,
				default: () => []
			}
		},
		computed: {
			busy() {
				return this.fetching
			}
		},
		mounted() {
			this.$translate.setLang(this.sitelocale);
		},
		locales: trans,
		data: () => ({
			merchants: [],
			order : [],
			currentPage: 0,
			fetching: false,
			nextUrl : String,
			loadMore : true,
			isActive: false,
			selectedCity: null,
			selectedCategory:null
		}),
		methods: {
			loadNextPage() {
				this.currentPage++;
				this.fetching = true;
				if(this.nextUrl != null){
					axios.get(this.nextUrl).then(({ data }) => {
						this.merchants.push(...data.data);
						if(data.links.next != null) {
							this.nextUrl = data.links.next;
						} else {
							this.nextUrl = data.links.next;
						}
						this.fetching = false;
					});
				}
				else{
					this.loadMore = false;
				}
			},
			selectWithId ({ value }) {
			    console.log(value)
				return `${value}`
			}
		},
		created() {
			this.nextUrl = this.url;
			this.merchants = [];
			this.loadNextPage();
		},
        watch: {
            selectedCategory: function (val) {
                this.merchants = [];
                axios.get(this.url, {params: {'city_id': this.selectedCity ? this.selectedCity.id : 'all', 'category_id': val.id}
                    })
                    .then(({data}) => {
                        this.merchants = data.data;
                        if (data.links.next != null) {
                            this.loadMore = true;
                            this.nextUrl = data.links.next;
                        } else {
                            this.nextUrl = data.links.next;
                            this.loadMore = false;

                        }
                        this.currentPage = 0;
                        this.fetching = false;
                    });
            },
            selectedCity: function (val) {
                this.merchants = [];
                axios.get(this.url, {params: {'city_id': val.id, 'category_id': this.selectedCategory ? this.selectedCategory.id : 'all'}
                    })
                    .then(({data}) => {
                    this.merchants = data.data;
                    if (data.links.next != null) {
                        this.loadMore = true;
                        this.nextUrl = data.links.next;
                    } else {
                        this.loadMore = false;
                        this.nextUrl = data.links.next;
                    }
                    this.currentPage = 0;
                    this.fetching = false;
                });
            }
        }
	};
</script>
<style lang="scss">

</style>
